import React, { SVGProps } from 'react';

export const IconsLgcLogo = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg xmlns='http://www.w3.org/2000/svg' width={43} height={43} viewBox='0 0 43 43' {...props}>
    <path
      d='M33.366 20.405c-.402-6.011-5.364-10.82-11.384-11.05-6.77-.257-12.338 5.155-12.338 11.867 0 4.75 2.79 8.847 6.82 10.746l1.905-3.3c.4-.692.205-1.584-.46-2.028a6.501 6.501 0 01-2.89-5.811c.19-3.252 2.832-5.904 6.083-6.106a6.514 6.514 0 016.929 6.5 6.503 6.503 0 01-2.892 5.411 1.527 1.527 0 00-.47 2.034l1.905 3.3a11.875 11.875 0 006.792-11.563zM21.009.16C9.669.428.49 9.8.45 21.145.421 29.33 5.063 36.43 11.86 39.944l1.9-3.29c.413-.717.197-1.643-.506-2.079-4.595-2.85-7.612-8.003-7.432-13.849.25-8.143 6.816-14.817 14.955-15.192 9.011-.416 16.448 6.768 16.448 15.688 0 5.633-2.968 10.572-7.423 13.343a1.536 1.536 0 00-.531 2.073l1.908 3.306c6.775-3.503 11.409-10.57 11.409-18.722C42.587 9.417 32.877-.12 21.009.16z'
      fill='#D8DFED'
      fillRule='evenodd'
    />
  </svg>
);
export default IconsLgcLogo;
